import { render, staticRenderFns } from "./basicNews.vue?vue&type=template&id=7deb1ecf&scoped=true"
import script from "./basicNews.vue?vue&type=script&lang=js"
export * from "./basicNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deb1ecf",
  null
  
)

export default component.exports